import './App.css';
import Header from './components/Header';
import SpacexMissions from './components/SpacexMissions';
import Footer from './components/Footer';
function App() {
  return (
    <div className="App">
        <Header/>
        <SpacexMissions/>
        <Footer/>
    </div>
  );
}

export default App;
